export default "__VITE_ASSET__BUdMz0Rj__"